/* rv-short-list.js: "The Short List, poured" (DESIGN-SYSTEM.md §10). Notes in sections/rv-short-list.liquid. */
(() => {
  if (customElements.get('rv-short-list')) return;
  const D = document;
  const MODES = ['is-motion', 'is-sda', 'is-io', 'is-tight', 'is-tighter', 'is-tightest'];
  const fire =(name, detail, cancelable) => {
    const e = new CustomEvent(name, { detail, cancelable });
    D.dispatchEvent(e);
    return e;
  };

  customElements.define(
    'rv-short-list',
    class extends HTMLElement {
      connectedCallback() {
        const $ = (s) => this.querySelector(s);
        this.opts = [...this.querySelectorAll('[data-handle]')];
        this.lists = [...this.querySelectorAll('[data-list]')];
        this.bands = [...this.querySelectorAll('.rv-band')];
        this.track = $('.rv-short-list__track');
        this.stage = $('.rv-short-list__stage');
        this.result = $('.rv-result');
        this.form = $('[data-rv-add-form]');
        this.btn = this.form && this.form.querySelector('button');
        this.err = this.form && this.form.querySelector('.rv-form-error');
        this.resolve = $('.rv-result__resolve');
        this.duo = $('[data-rv-duo]');
        this.foot = $('[data-rv-foot]');

        const foot = this.foot;
        if (foot) foot.hidden = false;
        this.opts.forEach((b) => (b.onclick = () => this.pick(b, true)));
        this.onFlavor = (e) => {
          const b = this.opt(e.detail && e.detail.handle);
          if (b) this.pick(b);
        };
        this.onDone = (e) => this.done(e);
        D.addEventListener('rv:flavor-change', this.onFlavor);
        D.addEventListener('rv:cart-add', this.onDone);
        D.addEventListener('rv:cart-error', this.onDone);
        const start =
          this.opt(D.documentElement.dataset.rvFlavor) ||
          this.opts.find((b) => b.getAttribute('aria-pressed') === 'true') ||
          this.opts[0];
        if (start) this.pick(start);

        if (this.form) this.form.addEventListener('submit', (e) => this.add(e));
        if (this.btn && D.querySelector('cart-drawer')) this.btn.setAttribute('aria-haspopup', 'dialog');
        const skip = $('[data-rv-skip]');
        if (skip) skip.addEventListener('click', (e) => this.skip(e));
        const duo = this.duo;
        if (duo && duo.getAttribute('href') === '#buy') {
          if (!D.getElementById('buy')) duo.href = this.dataset.shopUrl;
          else if (this.opts[0]) duo.onclick = () => fire('rv:flavor-change', { ...this.detail(this.opts[0]), handle: 'duo', name: 'Duo' });
        }

        this.rm = matchMedia('(prefers-reduced-motion: reduce)');
        this.update = () => this.mode();
        this.rm.addEventListener('change', this.update);
        this.onResize = () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            if (this.w !== innerWidth || Math.abs(this.h - innerHeight) > 120) this.mode();
          }, 200);
        };
        addEventListener('resize', this.onResize);
        this.mode();
        if (D.fonts) D.fonts.ready.then(this.update);
        if (window.Shopify && Shopify.designMode) {
          this.onBlock = (e) => this.toBlock(e);
          D.addEventListener('shopify:block:select', this.onBlock);
        }
      }

      disconnectedCallback() {
        D.removeEventListener('rv:flavor-change', this.onFlavor);
        D.removeEventListener('rv:cart-add', this.onDone);
        D.removeEventListener('rv:cart-error', this.onDone);
        D.removeEventListener('shopify:block:select', this.onBlock);
        removeEventListener('resize', this.onResize);
        this.rm && this.rm.removeEventListener('change', this.update);
        this.watch(false);
      }

      opt(handle) {
        return this.opts.find((b) => b.dataset.handle === handle);
      }
      detail(b) {
        const d = { handle: b.dataset.handle, name: b.dataset.name, source: 'short-list' };
        for (const k of ['accent', 'deep', 'tint']) d[k] = b.getAttribute('data-rv-' + k);
        return d;
      }

      pick(b, user) {
        const d = b.dataset;
        const detail = this.detail(b);
        this.cur = b;
        this.opts.forEach((o) => o.setAttribute('aria-pressed', o === b));
        this.lists.forEach((l) => (l.hidden = l.dataset.list !== d.handle));
        for (const k of ['accent', 'deep', 'tint']) if (detail[k]) this.style.setProperty('--rv-flavor-' + k, detail[k]);
        if (this.btn) {
          const out = 'soldout' in d;
          this.form.querySelector('[name="id"]').value = d.vid;
          if (!this.busy) this.btn.textContent = d.add;
          this.btn.disabled = out;
          this.btn.setAttribute('aria-disabled', out);
          this.fail();
        }
        if (user) fire('rv:flavor-change', detail);
      }

      mode() {
        if (!this.isConnected) return;
        const c = this.classList;
        const q = (location.search.match(/[?&]rv-sl=(\w+)/) || [])[1] || this.dataset.engine;
        const on = q !== 'static' && !this.rm.matches && +this.dataset.n > 0 && this.pinnable();
        const sda = q !== 'io' && window.CSS && CSS.supports('animation-timeline: view()');
        this.w = innerWidth;
        this.h = innerHeight;
        c.remove(...MODES);
        if (on) {
          c.add('is-motion', sda ? 'is-sda' : 'is-io');
          if (this.foot) this.style.setProperty('--rv-sl-foot', this.foot.offsetHeight + 'px');
          /* The result must clear the toggle for every flavor: the roomy layout, then three tighter ones (the last
             drops the result's second sentence, for iPhone Safari's ~660px with toolbars). Then the label must fit the
             stage. Otherwise the static side-by-side. */
          const s = this.stage;
          const fit = ['', 'is-tight', 'is-tighter', 'is-tightest'].some((t) => (t && c.add(t), this.clears(true)));
          if (!fit || s.scrollHeight > s.clientHeight + 4) c.remove(...MODES);
        }
        this.watch(c.contains('is-motion'));
      }
      /* True when the resolve group ends at least 10px above the toggle, the air the result's CSS bottom padding
         leaves (with `all`, for every flavor: the tallest list and the longest button label). Layout offsets, so the
         result's rise (a transform) doesn't count. Only the phone/tablet result is absolute over the stage; on
         desktop it sits in its own grid rows and can't overlap. */
      clears(all) {
        const r = this.result;
        const rs = this.resolve;
        const f = this.foot;
        if (!rs || !f || getComputedStyle(r).position !== 'absolute') return true;
        const fit = () => r.offsetTop + rs.offsetTop + rs.offsetHeight + 10 <= f.offsetTop;
        if (!all || this.busy || !this.opts.length) return fit();
        const was = this.lists.map((l) => l.hidden);
        const txt = this.btn && this.btn.textContent;
        const ok = this.opts.every((b) => {
          this.lists.forEach((l) => (l.hidden = l.dataset.list !== b.dataset.handle));
          if (this.btn) this.btn.textContent = b.dataset.add;
          return fit();
        });
        this.lists.forEach((l, i) => (l.hidden = was[i]));
        if (this.btn) this.btn.textContent = txt;
        return ok;
      }
      pinnable() {
        for (let el = this.parentElement; el && el !== D.body; el = el.parentElement) {
          const o = getComputedStyle(el);
          if (/auto|scroll|hidden/.test(o.overflowX + o.overflowY)) return false;
        }
        return true;
      }

      watch(on) {
        if (on && !this.io) {
          const live = {};
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => (live[e.target.dataset.i] = e.isIntersecting));
              let step = 0;
              for (let i = this.bands.length - 1; i > 0; i--)
                if (live[i]) {
                  step = i;
                  break;
                }
              if (this.classList.contains('is-io')) this.style.setProperty('--p', step);
              this.dataset.step = step;
              this.toggleAttribute('data-done', step >= +this.dataset.steps);
            },
            { rootMargin: '-50% 0px -49% 0px' }
          );
          this.bands.forEach((b) => this.io.observe(b));
        } else if (!on && this.io) {
          this.io.disconnect();
          this.io = null;
          this.style.removeProperty('--p');
          this.removeAttribute('data-done');
          delete this.dataset.step;
        }
      }
      /* one step = half of the stage's viewport (svh, measured from the pinned stage, not innerHeight) */
      scrollToStep(k) {
        const s = this.stage;
        const r = this.track.getBoundingClientRect();
        const pin = parseFloat(getComputedStyle(s).top) || 0;
        const end = r.bottom - pin - s.offsetHeight;
        scrollTo(scrollX, scrollY + Math.min(r.top - pin + (k * (s.offsetHeight + pin)) / 2, end));
      }

      skip(e) {
        if (!this.classList.contains('is-motion')) return;
        e.preventDefault();
        this.scrollToStep(+this.dataset.steps);
        setTimeout(() => this.result.focus({ preventScroll: true }), 80);
      }
      toBlock(e) {
        if (!this.classList.contains('is-motion') || !this.contains(e.target)) return;
        const k = [...this.querySelectorAll('.rv-gone [data-shopify-editor-block]')].indexOf(e.target) + 1;
        if (k > 0) this.scrollToStep(k);
      }

      /* The add goes through the page's buy box (one code path for cart events, pixels and the drawer):
         the box first follows this flavor, then adds it on "rv:sticky-add". If no buy box can add exactly
         this flavor, the form posts natively to /cart/add. */
      add(e) {
        if (this.busy) return e.preventDefault();
        const h = this.cur && this.cur.dataset.handle;
        const box = D.querySelector('#buy rv-buy-box') || D.querySelector('rv-buy-box');
        if (!h || !box || !box.find || !box.find(h)) return;
        if (box.busy) return e.preventDefault();
        fire('rv:flavor-change', this.detail(this.cur));
        if (!box.state || box.state.handle !== h) return;
        if (!fire('rv:sticky-add', { target: '#buy', handle: h, source: 'short-list' }, true).defaultPrevented) return;
        e.preventDefault();
        const b = this.btn;
        this.busy = box;
        this.fail();
        b.style.minWidth = b.offsetWidth + 'px';
        b.setAttribute('aria-busy', 'true');
        b.textContent = this.dataset.adding;
        this.t = setTimeout(() => this.done({ detail: { source: box } }), 10000);
      }
      done(e) {
        const d = e.detail || {};
        const b = this.btn;
        if (!this.busy || d.source !== this.busy) return;
        clearTimeout(this.t);
        this.busy = null;
        b.removeAttribute('aria-busy');
        b.style.minWidth = '';
        b.textContent = this.cur.dataset.add;
        if (e.type === 'rv:cart-error') this.fail(d.message || this.dataset.error);
      }
      /* Show (msg) or clear the add error. In motion mode the error line must not push the resolve into the toggle:
         tighten (never loosen, never go static mid-add); as a last resort the error takes the Duo link's place. */
      fail(msg) {
        const e = this.err;
        const c = this.classList;
        if (!e) return;
        e.hidden = !msg;
        if (msg) e.lastElementChild.textContent = msg;
        if (this.duo) this.duo.hidden = false;
        if (!msg || !c.contains('is-motion')) return;
        for (const t of ['is-tight', 'is-tighter', 'is-tightest']) {
          if (this.clears()) return;
          c.add(t);
        }
        if (this.duo && !this.clears()) this.duo.hidden = true;
      }
    }
  );
})();
